const explains = {
  // Cover
  QSRank: {
    title: "QS Ranking",
    href: "https://www.topuniversities.com/universities/imperial-college-london"
  },
  EIE: {
    title: "Electronic and Information Engineering",
    href: "https://www.imperial.ac.uk/study/ug/courses/electrical-engineering-department/electronic-information-meng/#structure"
  },
  RaftRef: {
    proj: "raft",
    title: "A consensus algorithm that can resist non-Byzantine fault, have same fault-tolerance and performance as Paxos",
    href: "https://raft.github.io/"
  },
  Elixir: {
    title: "A dynamic, functional language that leverages the Erlang VM, known for running low-latency, distributed and fault-tolerant systems.",
    href: "https://elixir-lang.org/"
  },

  Balena:{
    title: "Docker Daemon for Embedded Device",
    children: "Balena",
    href: "https://www.balena.io/"
  },
  BalenaOS:{
    children: "Balena OS",
    href: "https://www.balena.io/os"
  },
  BalenaCloud:{
    children: "Balena Cloud",
    href: "https://www.balena.io/cloud"
  },
  DockerCompose:{
    children: "Docker Compose",
    href: "https://docs.docker.com/compose/"
  },
  Alpine:{
    children: "Alpine Linux",
    href: "https://alpinelinux.org/"
  },
  Samba:{
    children: "Samba",
    title: "NAS and print service for both Linux and Windows",
    href: "https://www.samba.org/"
  },

  MQTT:{
    children: "MQTT",
    title: "A lightweight messaging protocol",
    href: "http://mqtt.org/"
  },
  HA:{
    children: "Home Assistant",
    title: "Open Source Hub",
    href: "https://www.home-assistant.io/"
  },
  AD:{
    children: "App Daemon",
    title: "Thread Pool Library to Host Automation",
    href: "https://appdaemon.readthedocs.io/en/latest/"
  },

  Travis:{
    children: "Travis CI",
    title: "Continuous Integration Test",
    href: "https://travis-ci.org/"
  },

  SIPOC:{
    title: "Suppliers, Inputs, Process, Outputs, and Customers",
    href: "https://en.wikipedia.org/wiki/SIPOC"
  },
  Confluence:{
    title: "Internal Wiki page",
    href: "https://www.atlassian.com/software/confluence"
  },
  Gerrit:{
    title: "Code review for Git",
    href: "https://www.gerritcodereview.com/"
  },
  Jira:{
    title: "Task management",
    href: "https://www.atlassian.com/software/jira"
  },

  goodManagement:{
    title: ""
  },
  goodOrganization:{
    title: ""
  },

  // Raft project
  Beam:{
    href: "https://en.wikipedia.org/wiki/BEAM_(Erlang_virtual_machine)"
  },
  RaftPaper:{
    title: "In Search of an Understandable Consensus Algorithm (Extended Version)",
    href: "https://raft.github.io/raft.pdf"
  },

  // portfolio project
  React: {
    title: "React Homepage",
    href: "https://reactjs.org/"
  },
  ReactHook: {
    title: "React Hook",
    href: "https://reactjs.org/docs/hooks-intro.html"
  },
  FP: {
    title: "Functional programming",
    href: "https://en.wikipedia.org/wiki/Functional_programming"
  },
  MUI:{
    title: "Material-UI Homepage",
    href: "http://material-ui.com/"
  },
  ExpressJs:{
    title: "Express Js Homepage",
    href: "https://expressjs.com/"
  },
  GithubAva: {
    href: "https://www.githubstatus.com/uptime"
  },
  GcloudCli: {
    title: "Setup guide for Firebase CLI",
    href: "https://firebase.google.com/docs/cli"
  },

  // smart project
  PhilipsHue: {
    href: 'https://www.philips-hue.com/en-gb',
  },
  Aqara:{
    href: 'https://www.aqara.com/en/home.html',
  },
  Z2M:{
    href: 'https://www.zigbee2mqtt.io/',
    children: 'Zigbee2MQTT'
  },
  SpritThermostat:{
    href: 'https://www.zigbee2mqtt.io/information/supported_devices.html#eurotronic'
  },

  //


}


export default explains;